/* 🤖 this file was generated by svg-to-ts */
export const matIconNextWeek: {
  name: 'next-week';
  data: string;
} = {
  name: 'next-week',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m11 18.5 4-4-4-4-1 1 3 3-3 3zM20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm10 15H4V9h16v11z"/></svg>`
};
